const getters = {
  id: state => state.user.id,
  token: state => state.user.token,
  username: state => state.user.name,
  email: state => state.user.email,
  privateKey: state => state.user.privateKey,
  isAdmin: state => state.user.isAdmin,
}
export default getters
